import * as React from "react";

export default class TContext<T> {
    /**
     * context
     *
     * @type {React.Context<T>}
     * @memberof TContext
     */
    context: React.Context<T>;

    value: T;

    constructor(value: T) {
        this.value = value;
        this.context = React.createContext(value);
    }

    /**
     * 注册provider
     * @param value
     * @param children
     */
    provider(value: T, children?: any, props?: any) {
        const { Provider } = this.context;
        return (
            <Provider value={value} {...props}>
                {children}
            </Provider>
        );
    }

    /**
     * 监听context
     * @param func
     */
    consumer(func: (context: T) => any, props?: {}) {
        const { Consumer } = this.context;
        return (
            <Consumer {...props}>
                {context => {
                    return func(context);
                }}
            </Consumer>
        );
    }
}
